import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { RequirePermission } from "@/libs/guard/admin-permission-guard";

// Dashboard
const DashboardPage = lazy(
  () => import("@/features/admin-view/dashboard/pages/dashboard-page"),
);
const EditSchoolPage = lazy(
  () => import("@/features/admin-view/dashboard/pages/edit-school"),
);

// Profile
const UserProfilePage = lazy(
  () => import("@/features/admin-view/profile/pages/user-profile"),
);

const StatisticsPage = lazy(
  () => import("@/features/admin-view/statistics/pages/index"),
);
const MentorDashboardPage = lazy(
  () => import("@/features/admin-view/mentor-dashboard/pages/mentor-dashboard"),
);
const MentorOverviewPage = lazy(
  () => import("@/features/admin-view/mentor-overview/pages/mentor-overview"),
);
const MentorOverviewDetailPage = lazy(
  () =>
    import("@/features/admin-view/mentor-overview/pages/mentor-overview-detail"),
);
const MentorStudentsPage = lazy(() =>
  import("@/features/admin-view/mentor-dashboard/pages/mentor-paginated-pages").then(
    (module) => ({ default: module.MentorStudentsPage }),
  ),
);
const MentorReviewQueuePage = lazy(() =>
  import("@/features/admin-view/mentor-dashboard/pages/mentor-paginated-pages").then(
    (module) => ({ default: module.MentorReviewQueuePage }),
  ),
);
const MentorAttentionPage = lazy(() =>
  import("@/features/admin-view/mentor-dashboard/pages/mentor-paginated-pages").then(
    (module) => ({ default: module.MentorAttentionPage }),
  ),
);
const SchoolAttentionPage = lazy(
  () => import("@/features/admin-view/attention/pages/school-attention"),
);

export const dashboardRoutes: RouteObject[] = [
  {
    index: true,
    element: <DashboardPage />,
  },
  {
    path: "/admin/profile",
    element: <UserProfilePage />,
  },
  {
    path: "/admin/school/edit/:slug",
    element: (
      <RequirePermission resource="school" scope="edit">
        <EditSchoolPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/statistics",
    element: <StatisticsPage />,
  },
  {
    path: "/admin/attention",
    element: (
      <RequirePermission resource="students" scope="view">
        <SchoolAttentionPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/mentor-dashboard",
    element: <MentorDashboardPage />,
  },
  {
    path: "/admin/mentor-dashboard/students",
    element: <MentorStudentsPage />,
  },
  {
    path: "/admin/mentor-dashboard/review-queue",
    element: <MentorReviewQueuePage />,
  },
  {
    path: "/admin/mentor-dashboard/attention",
    element: <MentorAttentionPage />,
  },
  {
    path: "/admin/mentor-overview",
    element: <MentorOverviewPage />,
  },
  {
    path: "/admin/mentor-overview/:mentorIdpId",
    element: <MentorOverviewDetailPage />,
  },
  {
    path: "/admin/mentor-overview/:mentorIdpId/students",
    element: <MentorStudentsPage />,
  },
  {
    path: "/admin/mentor-overview/:mentorIdpId/review-queue",
    element: <MentorReviewQueuePage />,
  },
  {
    path: "/admin/mentor-overview/:mentorIdpId/attention",
    element: <MentorAttentionPage />,
  },
];
